import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { ThemeProvider } from 'next-themes';
import { Toaster } from '@/components/ui/toaster';
import { useToast } from '@/components/ui/use-toast';
import { AuthProvider } from './contexts/AuthContext';
import { AdminSaveProvider } from './contexts/AdminSaveContext';
import { AppLayout } from './components/layout/AppLayout';
import { AdminLayout } from './components/layout/AdminLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminProtectedRoute } from './components/AdminProtectedRoute';
import { DataInputProtectedRoute } from './components/DataInputProtectedRoute';
import { Favicon } from './components/Favicon';
import Navigation from "@/components/Navigation";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { routes } from "@/routes";
import { LoadingFallback } from "./components/ui/loading";
import { queryClient } from "./lib/queryClient";
import "@/globals.css";

function App() {
  return (
    <AuthProvider>
      <AdminSaveProvider>
        <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={createBrowserRouter(routes)} />
            <Toaster />
          </QueryClientProvider>
        </ThemeProvider>
      </AdminSaveProvider>
    </AuthProvider>
  );
}

export default App;
